import { jsx } from "react/jsx-runtime";
import { useClassName } from "@contember/react-utils";
import { memo } from "react";
import { Text } from "./Text.js";
const Description = memo(({ className, children }) => {
  return /* @__PURE__ */ jsx(Text, { className: useClassName("description", className), children });
});
Description.displayName = "Description";
export {
  Description
};
//# sourceMappingURL=Description.js.map
